export enum Labels {
  managementId = "30031196",
  searchId = "177733",
  pagesId = "3127385606431179463",
  mailSettingsId = "3127888342503391797",
  usersPermissionsId = "3127888342503391804",
  transactionsReportId = "3127888342503391811",
  usersId = "3127424743599289208",
  productsId = "3125408374850591185",
  notificationsId = "3127385606431179632",
  welcomeId = "3127908561514926215",
  welcomeTitleId = '3127908561514926279',
  notificationsTitleId = "3127908561514926227",
  notificationsIntroId = "3127908561514926228",
  settingsIntroId = "3127908561514926229",
  searchIntroId = "3127908561514926230",
  languageIntroId = "3127908561514926231",
  currencyIntroId = "3127908561514926232",
  profileMenuIntroId = "3127908561514926233",
  profileMenuTitleId = "3127888342503391763",
  nextId = "3127850877520447860",
  previousId = "3127850877520447869",
  finishId = "3127908561514926271",
  subMainId = '3127908561514926303',
  subMainTitleId = '3127908561514926310',
  subPlatformId = '3127908561514926294',
  subPlatformTitleId = '3127218632900215046',
}
